/* eslint-disable jsx-a11y/img-redundant-alt */
import { DataGrid } from "@mui/x-data-grid";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./datatable.scss";
import BASE_URL from "../../../config/apiConfig";
function DataTable() {
  const [data, setData] = useState([]);

  // Fetch user data from API on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const userResponse = await axios.get(`${BASE_URL}/api/admin/users`);
        const transformedData = userResponse.data.map((user) => ({
          id: user.id,
          username: user.user_name,
          email: user.email,
          image: "", // Placeholder for user image if you have one
          status: user.is_verified ? "active" : "passive",
          age: "", // Placeholder for age if needed
        }));
        setData(transformedData);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchData();
  }, []);

  const handleDlt = (id) => {
    setData(data.filter((item) => item.id !== id));
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 310,
      renderCell: (param) => (
        <div className="userr">
          <img
            src="/Images/defaultProfileDp.png"
            alt="User"
            className="userr_image"
          />
          {param.row.id}
        </div>
      ),
    },
    {
      field: "username",
      headerName: "Username",
      width: 180,
    },
    { field: "email", headerName: "Email", width: 280 },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      renderCell: (param) => (
        <div className={`status ${param.row.status}`}>{param.row.status}</div>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      width: 170,
      renderCell: (params) => (
        <div className="actionn">
          <Link to={params.row.id}>
            <button type="button" className="view_btn">
              View
            </button>
          </Link>
          <button
            type="button"
            className="delete_btn"
            onClick={() => handleDlt(params.row.id)}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      {/* <div className="btnn">
        <Link style={{ textDecoration: "none" }}>
          <button type="button">Add New </button>
        </Link>
      </div> */}

      <div className="data_table">
        <DataGrid
          className="data_grid"
          rows={data}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10]}
          checkboxSelection
          autoHeight
          disableSelectionOnClick
        />
      </div>
    </>
  );
}

export default DataTable;
